import get from 'lodash/get';
import * as tagAllFeedActions from '../../action_creators/tag/tag_all_feed_action_creators';
import TagAllFeedModel from '../../../models/tag/tag_all_feed';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';
import log from '../../../services/logger_service';

export default function fetchTag(params, store, shouldNot404) {
  return function firstDispatch(dispatch) {
    dispatch(tagAllFeedActions.tagAllFeedLoading({}, store));
    return TagAllFeedModel.fetch(params, store)
      .then(function handleTagDetailData(TagData) {
        if (params.page && !get(TagData, 'data.posts.length')) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        }
        dispatch(tagAllFeedActions.tagAllFeedLoaded(TagData.data, store));
      })
      .catch(function handleUserError(err) {
        const status = get(err, 'response.status') || 500;
        if (!shouldNot404) {
          if (status === 404) {
            dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
          } else {
            dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
            log.error(
              err,
              `Error in tag all feed actions, message: ${err.message}`
            );
          }
        }
        dispatch(tagAllFeedActions.tagAllFeedLoadError(err, store));
      });
  };
}
